type Props = Readonly<{
  icon: string;
  iconColorHexCode?: string;
  name: string;
}>;

export default function TreeElementLabel({
  icon,
  iconColorHexCode,
  name,
}: Props): JSX.Element {
  return (
    <>
      <i
        className={`${icon} me-1`}
        aria-hidden
        style={{
          color: iconColorHexCode,
          fontSize: '20px',
        }}
      />
      <span
        className='text-truncate'
        title={name}
        style={{ maxWidth: '380px' }}>
        {name}
      </span>
    </>
  );
}
